const REACT_APP_OKTA_CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID;
const REACT_APP_OKTA_ISSUER = process.env.REACT_APP_OKTA_ISSUER;
const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;

export const oktaConfig = {
  clientId: REACT_APP_OKTA_CLIENT_ID,
  issuer: REACT_APP_OKTA_ISSUER ? REACT_APP_OKTA_ISSUER : '',
  redirectUri: REACT_APP_BASE_URL + '/login',
  scopes: [
    'openid',
    'email',
    'profile',
    'pepappspendwiseroles',
    'pepappspendwisesectors',
    'pepappspendwisecategories',
   // 'pepappspendwiseuseremail',
    //'pepappspendwiseimpgpid',
    'offline_access',
  ],
  pkce: true,
  useRefreshTokens: true, // <--- this is the key line for refresh tokens
  disableHttpsCheck: false,
  tokenManager: {
    autoRenew: true,
    autoRemove: true,
    secure: true,
    expireEarlySeconds: 5 * 60,
  },
};
